import { defineStore } from "pinia";
import axios from 'axios';
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
export const useGajiSkemaCapegStore = defineStore('gajiSkemaCapegStore', {
    state: () => ({
        data: null
    }),
    getters: {
        filter(){
            return this.data.filter(g => g.nama);
        }
    },
    actions: {
        async get() {
          // Fetch data only if it hasn't been fetched before
          
          if (!this.data) {
            try {
              const config = {
                headers: {
                  Authorization: api.defaults.headers.common["Authorization"],
                  "content-type": "application/json",
                },
              };
              var pegawaiStatus = 3; //capeg
             
             
              var res = await axios.get(`${API_BASE_URL}/gajiSkema/${pegawaiStatus}`, config);
              this.data = res.data;
            } catch (error) {
              console.error('gajiSkemaCapegStore Error fetching:', error);
            }
          }

          return this.data;
         
        },
        // reset(){
        //     console.log("gajiSkemaCapegStore clear")
        //     this.data = null;
        //     // this.get();
            
        // }
        async reset() {  // Add async
          this.data = null;  // Clear the store
          
          const newData = await this.get();  // Fetch new data
          
          this.data = newData;  // Store the fetched data
          return this.data;  // Ensure reset() returns the data
      }
        
    },
     onInit() {
        this.get();
    },
    persist: true,
    onBeforeMount() {
      this.get();
  },

});